module.exports = __webpack_public_path__ + "static/media/img-location-tainan-en.6e92a43c.svg";